<!--<div fxFill fxLayout="column">-->
<!--<div fxLayoutAlign="space-evenly">-->
<div fxFill fxLayout="column">
  <mat-card appearance="outlined">
    <mat-card-header fxLayout="column" fxLayoutAlign="center">
      <div fxLayout="column" fxFlex="80%" fxLayoutAlign="center center">
        <div *ngIf="!isProd()" fxLayout="column" fxLayoutAlign="center center" class="color_warn" style="font-size: 24px">
          <div class="pulsate">PRE-PRODUCTION TEST SYSTEM!</div>
          <div class="pulsate">DO NOT REGISTER, SIGN IN, OR FILE PROTESTS!</div>
          <div>To File Or Access An Actual Protest, please go to <a href="https://epds.gao.gov" target="_blank"
                                                                    title="Link to epds.gao.gov">https://epds.gao.gov</a>
          </div>
        </div>

        <mat-card-title role="heading" aria-level="1">Welcome to GAO's Electronic Protest Docketing System (EPDS).
        </mat-card-title>
        <mat-card-subtitle role="heading" aria-level="2">Please sign in below or register as a new User.
        </mat-card-subtitle>
      </div>
    </mat-card-header>
  </mat-card>
  <form #f="ngForm" (ngSubmit)="onLogin(f.value)">
  <mat-card appearance="outlined" fxLayoutAlign="center center" fxLayout="column">
      <mat-card-header class="bg_color_primary login_header">
        <mat-card-title role="heading" aria-level="1" class="color_white">EPDS</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayoutAlign="center center" fxLayout="column" class="login_width">
        <mat-form-field floatLabel="always" fxFlexFill appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput name="email" ngModel type="email" max="320" required>
        </mat-form-field>
        <mat-form-field floatLabel="always" fxFlexFill appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput name="pwd" ngModel type="password" max="500" required>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center">
        <div fxLayout="column" fxLayoutGap="8px">
          <div fxLayoutAlign="center" fxLayoutGap="8px">
            <button mat-raised-button type="submit" color="primary" [disabled]="f.invalid">Sign me in</button>
            <button mat-raised-button color="primary" (click)="$event.preventDefault();onRegister()">Register as a new User</button>
          </div>

          <div>
            <a href="javascript:void(0)" (click)="$event.preventDefault();forgotPassword();" title="Link to forgot my password">I forgot my password</a>
          </div>
        </div>
      </mat-card-actions>
  </mat-card>
  </form>

  <mat-card appearance="outlined">
    <mat-card-content fxLayout="row" fxLayoutAlign="center">
      <div fxLayout="column" fxLayoutGap="8px" fxFlex="80%">
        <mat-divider></mat-divider>
        <mat-card-title role="heading" aria-level="1">Warning!</mat-card-title>
        <mat-card-subtitle role="heading" aria-level="2"> Upon Login You Agree to the Following Information:
        </mat-card-subtitle>
        <mat-divider></mat-divider>
        <ul><!--style="padding-top: 0px;"-->
          <li>You are accessing a U.S. Government information system,
            which includes (1) this computer, (2) this computer network, (3)
            all computers connected to this network, and (4) all devices and
            storage media attached to this network or to a computer on this
            network. This information system is provided for U.S.
            Government-authorized use only.
          </li>
          <li>Unauthorized or improper use of this system may result in
            disciplinary action, as well as civil and criminal penalties.
          </li>
          <li>
            <p>Subject to the provisions in 4 C.F.R. &sect; 21.1(g)
              and 21.4 and 4 C.F.R. part 81, which include procedures for
              protecting proprietary, confidential, and other procurement
              sensitive information, by using this information system, you
              understand and consent to the following:</p>
          </li>
        </ul>
        <ol><!--style="margin-left: 50px;"-->
          <ol><!-- TODO: link to user guide "userGuide()"-->
            <li>You have no reasonable expectation of privacy regarding
              any communications or data transiting or stored on this
              information system. At any time, the government may for any
              lawful government purpose monitor, intercept, search and seize
              any communication or data transiting or stored on this
              information system. Accordingly, pursuant to GAO&rsquo;s
              <a href="javascript:void(0)" (click)="userGuide()" title="Link to User Guide">Electronic Protest Docketing System
                Instructions</a>, the following personal identifiers should be excluded, or
              redacted when inclusion is necessary, from all filings, unless
              otherwise directed by GAO:
              <ul>
                <li><strong>Social Security Numbers.</strong> If an individual&rsquo;s Social
                  Security number must be included in a filing, only the last four
                  digits of the numbers should be used.
                </li>
              </ul>
              <p>&nbsp;</p>
              <ul>
                <li><strong>Dates of Birth.</strong> If an individual&rsquo;s date of birth
                  must be included in a filing, only the year should be used.
                </li>
              </ul>
              <p>&nbsp;</p>
              <ul>
                <li><strong>Financial Account Numbers.</strong> If a financial account number
                  is relevant to a filing, only the last four digits of the number
                  should be used.
                </li>
              </ul>
            </li>
          </ol>
          <ol start="2">
            <li>Any communications or data transiting or stored on this
              information system may be disclosed or used for any lawful
              government purpose.
            </li>
            <li>Your consent is final and irrevocable. You may not rely
              on any statements or informal policies purporting to provide you
              with any expectation of privacy regarding communications on this
              system, whether oral or written, by your supervisor or any other
              official, except GAO's Chief Information Officer.
            </li>
          </ol>
        </ol>
      </div>
    </mat-card-content>
  </mat-card>
</div>
